import { BrowserRouter } from "react-router-dom"
import { Container } from "./styles"
import ScrollAnimation from "react-animate-on-scroll"
import Illustration from "../../assets/illustration.svg"
import { NavHashLink } from "react-router-hash-link"
import linkedin from '../../assets/linkedin.svg'
import githubIcon from '../../assets/github.svg'
import whatsapp from '../../assets/whatsapp.svg'
import Hello from '../../assets/Hello.gif'
import telegram from '../../assets/email-download-svgrepo-com.svg'
export function Hero() {
  return (
    <Container id="home">
      <div className="hero-text">
        <ScrollAnimation animateIn="fadeInUp">
          <p>Hello <img src={Hello} alt="Hello" width="20px"/>, I'm</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
          <h1>Rahul R. Madawalkar</h1>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.4 * 1000}>
          <h3>Aspiring Cloud Engineer · Backend & AI · AWS Certified</h3>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.6 * 1000}>
          <p className="small-resume">B.E. Information Technology | CGPA: 9.0 · Ponda, Goa</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.8 * 1000}>
          <BrowserRouter>
            <NavHashLink smooth to="#contact" className="button" aria-label="Contact Rahul">Contact</NavHashLink>
            <a className="button outline" href="/static/media/Rahul_Madawalkar_Resume.pdf" target="_blank" rel="noreferrer" aria-label="Open resume">Resume</a>
          </BrowserRouter>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={1 * 1000}>
      <div className="social-media"><a
        href="https://linkedin.com/in/0x-rahul/"
        target="_blank"
        rel="noreferrer"
      >
        <img src={linkedin} alt="Linkedin" />
      </a>
        <a
          href="https://github.com/CryptoMaN-Rahul"
          target="_blank"
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>
        <a
          href="https://api.whatsapp.com/send/?phone=%2B918767307108&text=Hello+Rahul+I+found+your+contact+through+portfolio+site.%0A%0A"
          target="_blank"
          rel="noreferrer"
        >
          <img src={whatsapp} alt="Whatsapp" />
        </a>
        <a
          href="mailto:rahulmadwalkar5@gmail.com"
          target="_blank"
          rel="noreferrer"
        >
          <img src={telegram} alt="Email" />
        </a></div>
        </ScrollAnimation>
      </div>
    <div className="hero-image" role="img" aria-label="Illustration representing Rahul">
        <ScrollAnimation animateIn="fadeInRight" delay={1 * 1000}>
      <img src={Illustration} alt="Illustration of Rahul working with cloud and AI" title="Rahul R. Madawalkar — Cloud & AI" />
        </ScrollAnimation>
      </div>
    </Container>
  )
}